export default __webpack_public_path__ + "static/media/iconRedPlus.079d5f0c.svg";